<!-- @Version: 1.0.2 --> 
<div class="button button-toggle-container" data-testid="downloadContainer" >
   <a data-testid="downloadLink" (click)="onKeyboardEnter()" cdkMonitorElementFocus target="_blank" (keyup.enter)="onKeyboardEnter()" (keydown.enter)="onKeyboardEnter()" [attr.href]="fieldItem.attribute_4" [attr.download]="fieldItem.attribute_2">
      <mat-button-toggle-group  class="set-color-unchecked" [formControl]="fcDownloadButton"  data-testid="toggle-group">
         <mat-button-toggle  [attr.color]="fcDownloadButton.dirty ?  colorSuccess : colorDefault" data-testid="click-button-download" >
            @if (iconDefault && iconSuccess) {
               <mat-icon data-testid="downloadIcon">{{fcDownloadButton.dirty ? iconSuccess : iconDefault}}</mat-icon>
            }{{fieldItem.attribute_6}}
         </mat-button-toggle>
            
      </mat-button-toggle-group>
   </a>
   @if (fieldItem.required && fcDownloadButton.pristine) {
      <mat-hint data-testid="required-hint">{{TRANSLATE_PATH.REQUIRED | translate}}</mat-hint>
   }
   @else if (fcDownloadButton.dirty) {
      <mat-hint data-testid="done-message">{{TRANSLATE_PATH.DOWNLOAD_DONE | translate}}</mat-hint>
   }
   @else {
      <mat-hint data-testid="hint-placeholder" class="visibility" aria-hidden="true">&nbsp;</mat-hint>
   }
</div>